import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";

export const useDeleteBudgetPlan = (onSuccess) => {
  const queryClient = useQueryClient();
  const mutationFn = useApiRequest({
    url: "/users/me/budget-plan",
    method: HttpMethod.Delete,
  });

  return useMutation({
    mutationKey: ["delete-user-budget-plan"],
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["budget-plan"] });

      queryClient.invalidateQueries({
        queryKey: ["user-journey"],
        exact: true,
      });
      queryClient.invalidateQueries({
        queryKey: ["user-journey-status"],
        exact: true,
      });

      onSuccess?.();
    },
  });
};
